(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7088,16165],{

/***/ 16165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1413);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41755);





var Icon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var className = props.className,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      restProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["className", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children"]);

  (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warning */ .Kp)(Boolean(Component || children), 'Should have `component` prop or `children`.');
  (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .useInsertStyles */ .C3)();
  var classString = classnames__WEBPACK_IMPORTED_MODULE_1___default()('anticon', className);
  var svgClassString = classnames__WEBPACK_IMPORTED_MODULE_1___default()({
    'anticon-spin': !!spin
  });
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _utils__WEBPACK_IMPORTED_MODULE_3__/* .svgBaseProps */ .vD), {}, {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  } // component > children


  var renderInnerNode = function renderInnerNode() {
    if (Component) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, innerSvgProps), children);
    }

    if (children) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .warning */ .Kp)(Boolean(viewBox) || react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children) === 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) && react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    return null;
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", Object.assign({
    role: "img"
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), renderInnerNode());
});
Icon.displayName = 'AntdIcon';
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 27049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59844);



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};





var Divider = function Divider(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_config_provider__WEBPACK_IMPORTED_MODULE_2__/* .ConfigConsumer */ .C, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;

    var customizePrefixCls = props.prefixCls,
        _props$type = props.type,
        type = _props$type === void 0 ? 'horizontal' : _props$type,
        _props$orientation = props.orientation,
        orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
        className = props.className,
        children = props.children,
        dashed = props.dashed,
        plain = props.plain,
        restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed", "plain"]);

    var prefixCls = getPrefixCls('divider', customizePrefixCls);
    var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
    var hasChildren = !!children;
    var classString = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-with-text"), hasChildren), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), hasChildren), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-plain"), !!plain), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      className: classString
    }, restProps, {
      role: "separator"
    }), children && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: "".concat(prefixCls, "-inner-text")
    }, children));
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Divider);

/***/ }),

/***/ 78343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),

/***/ 91296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 50550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-close {\n    top: 20px;\n    right: 30px;\n    font-size: 14px;\n    font-weight: bold;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    border: 0;\n    padding: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 40px 50px 30px;\n  }\n\n  .ant-modal-close {\n    top: 3%;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    height: 90%;\n    overflow-y: scroll;\n  }\n\n  @media ",
        " {\n    .ant-modal-content {\n      width: 660px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-f78b26fb-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}));


/***/ }),

/***/ 51129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ company_GuestRegisterModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/features/company/GuestRegisterModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  @media (min-width: 600px) {\n    border-radius: 6px;\n  }\n  @media ",
        " {\n    &.left-content img {\n      width: 400px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: 600px) {\n    padding: 17% 10% 0 10%;\n  }\n  @media ",
        " {\n    padding: 20% 10% 0 10%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: absolute;\n  text-align: center;\n  top: 30px;\n  left: 50%;\n  transform: translate3d(-50%, 0, 0);\n  div.title-banner {\n    color: #066c46;\n    font-size: 20px;\n    margin-bottom: 8px;\n    font-family: ProximaNovaBd;\n  }\n  p {\n    color: #066c46;\n    font-size: 13px;\n    margin-bottom: 0;\n  }\n\n  @media (min-width: 600px) {\n    top: 76px;\n    div.title-banner {\n      font-size: 19.6px;\n    }\n    p {\n      font-size: 11.2px;\n    }\n  }\n\n  @media ",
        " {\n    top: 109px;\n    div.title-banner {\n      font-size: 28px;\n    }\n    p {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: 600px) {\n    font-size: 9.8px;\n  }\n  @media ",
        " {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5%;\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    width: 66.51px;\n    height: 25.7px;\n  }\n  @media ",
        " {\n    img {\n      width: 95.02px;\n      height: 36.72px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: 19.6px;\n  font-family: ProximaNovaBd;\n  @media ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 10% 0 !important;\n  padding: 0 30px !important;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}







var RegisterModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-9787c327-0"
})(_templateObject(), device/* default.laptop */.Z.laptop);
var Container = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-9787c327-1"
})(_templateObject1(), device/* default.laptop */.Z.laptop);
var TitleBanner = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-9787c327-2"
})(_templateObject2(), device/* default.laptop */.Z.laptop);
var CustomText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-9787c327-3"
})(_templateObject3(), device/* default.laptop */.Z.laptop);
var ColEmailButton = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-9787c327-4"
})(_templateObject4(), color/* default.downgray */.Z.downgray);
var RowRegisterForm = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-9787c327-5"
})(_templateObject5());
var LogoContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9787c327-6"
})(_templateObject6(), device/* default.laptop */.Z.laptop);
var TitleForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9787c327-7"
})(_templateObject7(), device/* default.laptop */.Z.laptop);
var DividerText = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-9787c327-8"
})(_templateObject8());
var Footer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9787c327-9"
})(_templateObject9(), color/* default.downgray */.Z.downgray);


// EXTERNAL MODULE: ./src/features/company/styled.ts + 2 modules
var styled = __webpack_require__(23391);
// EXTERNAL MODULE: ./src/features/register/GoogleOauth/index.tsx
var GoogleOauth = __webpack_require__(79106);
// EXTERNAL MODULE: ./src/features/register/FacebookOauth/index.tsx
var FacebookOauth = __webpack_require__(72099);
// EXTERNAL MODULE: ./src/features/register/slice.ts + 1 modules
var slice = __webpack_require__(9260);
// EXTERNAL MODULE: ./src/features/register/constants.ts
var constants = __webpack_require__(28456);
;// CONCATENATED MODULE: ./src/features/company/GuestRegisterModal/index.tsx



















var getWindowSize = function() {
    if (false) {}
    var _documentElement = document.documentElement, width = _documentElement.clientWidth, height = _documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
};
var GuestRegisterModal = function(param) {
    var isCompanyStock = param.isCompanyStock, visible = param.visible, setVisible = param.setVisible, features = param.features;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(getWindowSize()), windowSize = ref[0], setWindowSize = ref[1];
    var isMobileView = windowSize.width < 600;
    var isTabletView = windowSize.width >= 600 && windowSize.width < 1024;
    var isLaptopView = windowSize.width >= 1024;
    var bannerWidth = isLaptopView ? 450 : 315;
    (0,react.useEffect)(function() {
        var handleWindowResize = function handleWindowResize() {
            setWindowSize(getWindowSize());
        };
        window.addEventListener("resize", handleWindowResize);
        return function() {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    var navigate = function() {
        if (!isMobileView) {
            dispatch(slice/* default.actions.changeForm */.ZP.actions.changeForm({
                target: constants/* formTypes.EMAIL */.o_.EMAIL
            }));
        }
        router.push("/register");
    };
    var renderNonStockModal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            type: "basic",
            visible: visible,
            onCancel: function() {
                return setVisible(!visible);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    padding: 30
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        as: "span",
                        family: "bold",
                        size: "36px",
                        children: [
                            "Daftar",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "span",
                        family: "bold",
                        size: "36px",
                        color: color/* default.primary */.Z.primary,
                        children: "Gratis"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "p",
                        family: "bold",
                        size: "18px",
                        children: "dan dapatkan:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        mt: "30px",
                        mb: "30px",
                        children: [
                            features.map(function(f) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    padding: "6px 0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                            className: f.icon,
                                            size: "24px",
                                            color: color/* default.black */.Z.black
                                        }, f.name),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            padding: "0 0 0 10px",
                                            size: "18px",
                                            children: f.name
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: color/* default.midgray */.Z.midgray,
                                size: "10px",
                                mt: "5px",
                                children: "*) Gratis Coba 30 Hari"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/register",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* RegisterButton */.DT, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: color/* default.light */.Z.light,
                                size: "20px",
                                family: "bold",
                                children: "Daftar Sekarang"
                            })
                        })
                    })
                ]
            })
        });
    };
    var renderStockModal = function() {
        // eslint-disable-next-line no-nested-ternary
        var imageBanner = isLaptopView ? "/images/pc-guest-banner.jpg" : isTabletView ? "/images/tablet-guest-banner.jpg" : "/images/mobile-guest-banner.jpg";
        var registerButtonText = isMobileView ? "Daftar Sekarang" : "Register with Email";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterModal, {
            centered: true,
            type: "basic",
            width: "100%",
            style: {
                maxWidth: isMobileView ? bannerWidth : bannerWidth * 2,
                paddingBottom: 0
            },
            visible: visible,
            onCancel: function() {
                return setVisible(!visible);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                        span: isMobileView ? 24 : 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleBanner, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "title-banner",
                                        children: "Daftar Stockbit Sekarang"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Gabung Komunitas Saham dan Dapatkan"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Berbagai ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Fitur Pro GRATIS"
                                            }),
                                            " Selama 30 Hari! \uD83D\uDE80"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "Register Sotckbit",
                                src: imageBanner,
                                style: {
                                    width: bannerWidth
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColEmailButton, {
                                span: isMobileView ? 24 : 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    block: true,
                                    // @ts-expect-error
                                    round: true,
                                    type: "primary",
                                    onClick: navigate,
                                    height: "44px",
                                    id: "email-register",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                        color: "light",
                                        family: "bold",
                                        children: registerButtonText
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: isMobileView ? 0 : 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowRegisterForm, {
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                                    span: 24,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                                            align: "center",
                                            justify: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: "/icon/stockbit-new.svg",
                                                alt: "Sotckbit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                            align: "center",
                                            justify: "center",
                                            margin: "10% 0 8% 0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleForm, {
                                                children: "Welcome to Stockbit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleOauth/* default */.Z, {
                                            isCompanyStock: true,
                                            variant: "secondary",
                                            size: isLaptopView ? "large" : "medium"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookOauth/* default */.Z, {
                                            isCompanyStock: true,
                                            variant: "secondary",
                                            size: isLaptopView ? "large" : "medium"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerText, {
                                            plain: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                                color: "#B5B5B5",
                                                family: "bold",
                                                children: "Or"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            block: true,
                                            // @ts-expect-error
                                            round: true,
                                            mb: "10%",
                                            type: "primary",
                                            onClick: navigate,
                                            height: "".concat(isLaptopView ? 35 : 30.8, "px"),
                                            id: "email-register",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                                color: "light",
                                                family: "bold",
                                                children: registerButtonText
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomText, {
                                            align: "center",
                                            children: [
                                                "Already have a Stockbit account?",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/login",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                                        as: "a",
                                                        family: "bold",
                                                        children: "Login"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        align: "center",
                                        justify: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomText, {
                                            align: "center",
                                            children: [
                                                "By signing up you agree with our",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/terms",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                                        as: "a",
                                                        children: " Terms & Conditions."
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    if (isCompanyStock) {
        return renderStockModal();
    }
    return renderNonStockModal();
};
/* harmony default export */ var company_GuestRegisterModal = (GuestRegisterModal);


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ })

}]);